import { useEffect } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import WNEPage from "./pages/WNEPage";
import PrintPage from "./pages/PrintPage";
import AdminPage from "./pages/AdminPage";
import LoginPage from "./pages/LoginPage";
import ErrorBoundary from "./components/ErrorBoundary";

function App() {
  useEffect(() => {
    // Set page title and meta
    document.title = "Congressional Energy Engagement Group | CEEF & CEE LLC";
    
    // Update meta description
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', 'Congressional Energy Engagement Group: Access our comprehensive nuclear energy report, watch our documentary film, and connect with CEE LLC and CEEF resources.');
    } else {
      const meta = document.createElement('meta');
      meta.name = 'description';
      meta.content = 'Congressional Energy Engagement Group: Access our comprehensive nuclear energy report, watch our documentary film, and connect with CEE LLC and CEEF resources.';
      document.head.appendChild(meta);
    }

    // Add Open Graph tags for social sharing
    const addMetaTag = (property, content) => {
      let tag = document.querySelector(`meta[property="${property}"]`);
      if (!tag) {
        tag = document.createElement('meta');
        tag.setAttribute('property', property);
        document.head.appendChild(tag);
      }
      tag.setAttribute('content', content);
    };

    addMetaTag('og:title', 'Congressional Energy Engagement Group');
    addMetaTag('og:description', 'Access our nuclear energy resources, reports, and documentary film');
    addMetaTag('og:type', 'website');
    addMetaTag('og:url', window.location.href);
  }, []);

  return (
    <ErrorBoundary>
      <div className="App">
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<WNEPage />} />
            <Route path="/wne" element={<WNEPage />} />
            <Route path="/print" element={<PrintPage />} />
            <Route path="/login" element={<LoginPage />} />
            <Route path="/admin" element={<AdminPage />} />
          </Routes>
        </BrowserRouter>
      </div>
    </ErrorBoundary>
  );
}

export default App;
